import React, { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Visibility } from '@material-ui/icons';
import { format, parseISO } from 'date-fns';
import { isArray } from 'lodash';

import { Modal, UnidataTable } from '~/components';
import { number, t } from '~/helpers';
import api from '~/services/api';
import { recordFiltering } from '~/store/modules/afericaoAreiaSilo/actions';

import Form from './form';
import View from './view';

function AfericaoAreiaSilo() {
  const redux = useSelector((state) => state.afericaoAreiaSilo);
  const modalRef = useRef(null);
  const [loadingView, setLoadingView] = useState(false);

  const buttons = useMemo(
    () => [
      {
        label: t('s.geral.botaofechar'),
        callback: () => modalRef.current.handleCloseModal(),
        color: 'secondary',
        autoFocus: true,
        variant: 'outlined',
      },
    ],
    []
  );

  const handleView = useCallback(async (value) => {
    try {
      setLoadingView(true);
      const { data } = await api.get(
        `afericaoareiasilo/${value.idafericaoareiasilo}`
      );
      modalRef.current.handleOpenModal({ data: { ...value, ...data } });
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoadingView(false);
    }
  }, []);

  const actions = useMemo(
    () => [
      {
        title: t('s.geral.visualizar'),
        action: (value) => handleView(value),
        icon: <Visibility />,
      },
    ],
    [handleView]
  );

  const header = useMemo(
    () => [
      {
        id: 'codigonomeposto',
        label: t('s.configuracao.terminal.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'datahoraafericaoareiasilo',
        label: t('s.operacao.afericaoareiasilo.datahora'),
        formatted: (value) =>
          value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : '',
      },
      {
        id: 'nomesiloafericaoareiasilo',
        label: t('s.operacao.afericaoareiasilo.silo'),
        filter: { type: 'text' },
      },
      {
        id: 'pesoafericaoareiasilo',
        label: `${t('s.geral.peso')} (Kg)`,
        label: 'Peso Kg',
        formatted: (value) => number(value || 0, '2'),
        filter: { type: 'number' },
      },
      {
        id: 'duracaoafericaoareiasilo',
        label: `${t('s.geral.duracao')} (s)`,
        filter: { type: 'number' },
      },
      {
        id: 'vazaoafericaoareiasilo',
        label: `${t('s.geral.vazao')} (Kg/s)`,
        formatted: (value) => number(value || 0, '4'),
        filter: { type: 'number' },
      },
      {
        id: 'nomeusuarioafericaoareiasilo',
        label: t('s.cadastro.usuario.usuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  return (
    <>
      <UnidataTable
        fixed
        redux={redux}
        header={header}
        read={recordFiltering}
        actions={actions}
        form={Form}
        update={false}
        delete={false}
        maxWidth="sm"
        keys="idafericaoareiasilo"
        detach="codigonomeposto"
      />

      <Modal
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        loading={loadingView}
        component={View}
        actions={buttons}
        title={t('s.menu.operacao.afericaoareiasilo')}
        maxWidth="md"
        noPadding
      />
    </>
  );
}

export default AfericaoAreiaSilo;
